import React, { useState } from 'react'
import * as ReactBootstrap from 'react-bootstrap'
import Moment from 'react-moment'
import { ICONS } from './icons'
import { JSONToHTMLTable } from '../common'
import { SuccessDisplay } from './SuccessDisplay'
import {ChangeLogViewer} from "../ChangeLogViwer/ChangeLogViewer";
export const BooleanConverter = function (value, cssClassName = 'text-center') {
  if (value) {
    return <div className={`${cssClassName} text-success`}>{ICONS.SUCCESS_TICK}</div>
  } else {
    return <div className={cssClassName}>{ICONS.FAILURE_TICK}</div>
  }
}

export const BooleanFormatterWithCSS = function (fieldName, cssClassName) {
  return function (cell, row) {
    return BooleanConverter(row[fieldName], cssClassName)
  }
}

export const CellTextFormatter = function (cell, row) {
  return <div className="text-left"> {cell} </div>
}

export const CellTextORNAFormatter = function (cell, row) {
   if (cell) {
     return <div className="text-left"> {cell} </div>
   }
   return 'N/A'
}

export const CellDateFormatter = function (cell, row) {
  if (cell) {
    return (
      <Moment format="DD-MM-YYYY" local>
        {cell}
      </Moment>
    )
  }
  return 'N/A'
}
export const ChangeLogFormatter = function (cell, row) {
  if (cell) {
    return (
      <ChangeLogViewer url={cell} />
    )
  }
  return <>N/A</>
}
export const CellDateTimeFormatter = function (cell, row) {
  if (cell) {
    return (
      <Moment format="DD-MM-YYYY hh:mm A" local>
        {cell}
      </Moment>
    )
  }
  return <>N/A</>
}

export const MomentFormatter = function (cell, _row) {
  return (
    <>
      <Moment parse="YYYY-MM-DD HH:mm">{cell}</Moment>
      <sub>
        <strong>
          <Moment fromNow>{cell}</Moment>
        </strong>
      </sub>
    </>
  )
}


export const upperCase = (value) => value && value.toUpperCase()
export const lowerCase = (value) => value && value.toLowerCase()

export const titleCase = (value) => {
  return (
    value &&
    value
      .toString()
      .toLowerCase()
      .split(' ')
      .map(function (word) {
        return word.charAt(0).toUpperCase() + word.slice(1)
      })
      .join(' ')
  )
}
export const titleCaseByUnderscore = (value) => {
  return (
    value &&
    value
      .toString()
      .toLowerCase()
      .split('_')
      .map(function (word) {
        return word.charAt(0).toUpperCase() + word.slice(1)
      })
      .join(' ')
  )
}

export const camel2title = (camelCase) =>
  camelCase
    .replace(/([A-Z])/g, (match) => ` ${match}`)
    .replace(/^./, (match) => match.toUpperCase())

const JSONToHTMLTableModal = ({ data, heading }) => {
  const [show, setShow] = useState(false)
  const handleClose = () => setShow(false)
  const open = () => setShow(true)

  return (
    <>
      <ReactBootstrap.Modal
        size="xl"
        backdrop="static"
        show={show}
        onHide={handleClose}
      >
        <ReactBootstrap.Modal.Header closeButton>
          {heading}
        </ReactBootstrap.Modal.Header>
        <ReactBootstrap.Modal.Body>
          {data ? (
            <JSONToHTMLTable
              data={data}
              tableClassName="table table-sm table-striped table-bordered"
            />
          ) : (
            <SuccessDisplay message={'No Results .'} />
          )}
        </ReactBootstrap.Modal.Body>
        <ReactBootstrap.Modal.Footer></ReactBootstrap.Modal.Footer>
      </ReactBootstrap.Modal>
      <ReactBootstrap.Button variant="dark" onClick={() => open()}>
        Open
      </ReactBootstrap.Button>
    </>
  )
}

export const JSONToHTMLTableFormatterText = function (text, disabled) {
  return function (cell, row) {
    if (disabled) {
      return ''
    }
    return <JSONToHTMLTableModal data={cell} heading={text} />
  }
}
